export const SearchFieldNames: string[] = [
  'orderIdAsString',
  'employee',
  'cnp',
  'eid',
  'state',
];

export const SearchCrtIdToFieldName: { [key: number]: string } = {
  1: SearchFieldNames[0],
  2: SearchFieldNames[1],
  3: SearchFieldNames[2],
  4: SearchFieldNames[3],
  5: SearchFieldNames[4],
};
